import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { TextingOptinBlock } from './texting-optin-block';
import { Component, inject } from '@angular/core';
import { SettingsPagesModule } from '@tytapp/app/pages/settings-pages';
import { UserService } from '@tytapp/user';
import { Subscription } from 'rxjs';
import { ApiUser } from '@tytapp/api';

@Component({
    selector: 'tyt-texting-optin-block',
    standalone: true,
    imports: [
        ContentModule,
        SettingsPagesModule
    ],
    template: `
        @if (user) { <!-- Currently only available for signed in users, anonymous signups will come later -->
            <tyt-content-card title="Text Alerts from TYT" [icon]="{ type: 'material', text: 'smartphone' }">
                <div class="actions">
                    <a mat-button url="/settings/messaging">
                        <mat-icon>settings</mat-icon>
                        Preferences
                    </a>
                </div>
                <div style="padding: 1em;">
                    <tyt-texting-optin />
                </div>
            </tyt-content-card>
        }
    `
})
export class ViewComponent extends ContentBlockViewComponent<TextingOptinBlock> {
    private userService = inject(UserService);
    private subscriptions = new Subscription();

    user: ApiUser;

    ngOnInit() {
        this.subscriptions.add(this.userService.userChanged.subscribe(user => this.user = user));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
